export default __webpack_public_path__ + "static/media/CameraShutter.16004285.svg";